export default __webpack_public_path__ + "static/media/Link-dark.af58e9b2.svg";